import Grid from "@mui/material/Grid2";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { TabSessionDataReAuthResponse } from "../../../../models/api/TabSessionStorage";
import { flexRow } from "../../../../styles/mui/styles/display";
import { tableCellHeader } from "../../../PriorAuthWorkFlow/styles/Review";
import colors from "../../../../styles/colors/colors";
import fontWeight from "../../../../styles/mui/fontWeight";
import { getValue } from "../../../../utils";

export interface PropsFromState {
  tabSessionStorage: TabSessionDataReAuthResponse;
}

type AllProps = PropsFromState;

const ICD10: React.FC<AllProps> = ({ tabSessionStorage }) => {

    const typography = (value: string) => {
      return (
        <Box color={colors.black[5]}>
          <Typography fontWeight={fontWeight[4]} lineHeight="1.3">
            {value}
          </Typography>
        </Box>
      );
    };

  return (
    <Grid container sx={flexRow}>
      <Grid size={{ xs: 12 }}>
        <Box sx={{ overflowX: "auto" }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={tableCellHeader}>Diagnosis Code</TableCell>
                <TableCell sx={tableCellHeader}>Description</TableCell>
                <TableCell sx={tableCellHeader}>Type</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                {(getValue(tabSessionStorage, "response.diagnosisCode") ?? []).map(
                ({
                  diagnosisCode,
                  diagnosisCodeDescription,
                  diagnosisType,
                }: any) => (
                  <TableRow key={diagnosisCode}>
                    <TableCell>
                      {typography(diagnosisCode)}
                    </TableCell>
                    <TableCell>{typography(diagnosisCodeDescription)}</TableCell>
                    <TableCell>{typography(diagnosisType)}</TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ICD10;